/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddCategoryToPlanCommandResult } from '../models/add-category-to-plan-command-result';
import { AddExcuseCommandResult } from '../models/add-excuse-command-result';
import { AddPlanProgressCommandResult } from '../models/add-plan-progress-command-result';
import { apiPlanAddCategoryToPlanPatch } from '../fn/plan/api-plan-add-category-to-plan-patch';
import { ApiPlanAddCategoryToPlanPatch$Params } from '../fn/plan/api-plan-add-category-to-plan-patch';
import { apiPlanAddCategoryToPlanPatch$Plain } from '../fn/plan/api-plan-add-category-to-plan-patch-plain';
import { ApiPlanAddCategoryToPlanPatch$Plain$Params } from '../fn/plan/api-plan-add-category-to-plan-patch-plain';
import { apiPlanAddExcusePost } from '../fn/plan/api-plan-add-excuse-post';
import { ApiPlanAddExcusePost$Params } from '../fn/plan/api-plan-add-excuse-post';
import { apiPlanAddExcusePost$Plain } from '../fn/plan/api-plan-add-excuse-post-plain';
import { ApiPlanAddExcusePost$Plain$Params } from '../fn/plan/api-plan-add-excuse-post-plain';
import { apiPlanAddInspectorEvaluationPatch } from '../fn/plan/api-plan-add-inspector-evaluation-patch';
import { ApiPlanAddInspectorEvaluationPatch$Params } from '../fn/plan/api-plan-add-inspector-evaluation-patch';
import { apiPlanAddInspectorEvaluationPatch$Plain } from '../fn/plan/api-plan-add-inspector-evaluation-patch-plain';
import { ApiPlanAddInspectorEvaluationPatch$Plain$Params } from '../fn/plan/api-plan-add-inspector-evaluation-patch-plain';
import { apiPlanAddPlanProgressPatch } from '../fn/plan/api-plan-add-plan-progress-patch';
import { ApiPlanAddPlanProgressPatch$Params } from '../fn/plan/api-plan-add-plan-progress-patch';
import { apiPlanAddPlanProgressPatch$Plain } from '../fn/plan/api-plan-add-plan-progress-patch-plain';
import { ApiPlanAddPlanProgressPatch$Plain$Params } from '../fn/plan/api-plan-add-plan-progress-patch-plain';
import { apiPlanAutoCreatePlanPost } from '../fn/plan/api-plan-auto-create-plan-post';
import { ApiPlanAutoCreatePlanPost$Params } from '../fn/plan/api-plan-auto-create-plan-post';
import { apiPlanAutoCreatePlanPost$Plain } from '../fn/plan/api-plan-auto-create-plan-post-plain';
import { ApiPlanAutoCreatePlanPost$Plain$Params } from '../fn/plan/api-plan-auto-create-plan-post-plain';
import { apiPlanChangeExcuseStatusPost } from '../fn/plan/api-plan-change-excuse-status-post';
import { ApiPlanChangeExcuseStatusPost$Params } from '../fn/plan/api-plan-change-excuse-status-post';
import { apiPlanChangeExcuseStatusPost$Plain } from '../fn/plan/api-plan-change-excuse-status-post-plain';
import { ApiPlanChangeExcuseStatusPost$Plain$Params } from '../fn/plan/api-plan-change-excuse-status-post-plain';
import { apiPlanChangePlanStatusPatch } from '../fn/plan/api-plan-change-plan-status-patch';
import { ApiPlanChangePlanStatusPatch$Params } from '../fn/plan/api-plan-change-plan-status-patch';
import { apiPlanChangePlanStatusPatch$Plain } from '../fn/plan/api-plan-change-plan-status-patch-plain';
import { ApiPlanChangePlanStatusPatch$Plain$Params } from '../fn/plan/api-plan-change-plan-status-patch-plain';
import { apiPlanCreatePlanPost } from '../fn/plan/api-plan-create-plan-post';
import { ApiPlanCreatePlanPost$Params } from '../fn/plan/api-plan-create-plan-post';
import { apiPlanCreatePlanPost$Plain } from '../fn/plan/api-plan-create-plan-post-plain';
import { ApiPlanCreatePlanPost$Plain$Params } from '../fn/plan/api-plan-create-plan-post-plain';
import { apiPlanDeletePlanDelete } from '../fn/plan/api-plan-delete-plan-delete';
import { ApiPlanDeletePlanDelete$Params } from '../fn/plan/api-plan-delete-plan-delete';
import { apiPlanDeletePlanDelete$Plain } from '../fn/plan/api-plan-delete-plan-delete-plain';
import { ApiPlanDeletePlanDelete$Plain$Params } from '../fn/plan/api-plan-delete-plan-delete-plain';
import { apiPlanGetAllInspectorsPost } from '../fn/plan/api-plan-get-all-inspectors-post';
import { ApiPlanGetAllInspectorsPost$Params } from '../fn/plan/api-plan-get-all-inspectors-post';
import { apiPlanGetAllInspectorsPost$Plain } from '../fn/plan/api-plan-get-all-inspectors-post-plain';
import { ApiPlanGetAllInspectorsPost$Plain$Params } from '../fn/plan/api-plan-get-all-inspectors-post-plain';
import { apiPlanGetNoteGet } from '../fn/plan/api-plan-get-note-get';
import { ApiPlanGetNoteGet$Params } from '../fn/plan/api-plan-get-note-get';
import { apiPlanGetNoteGet$Plain } from '../fn/plan/api-plan-get-note-get-plain';
import { ApiPlanGetNoteGet$Plain$Params } from '../fn/plan/api-plan-get-note-get-plain';
import { apiPlanGetPlanPost } from '../fn/plan/api-plan-get-plan-post';
import { ApiPlanGetPlanPost$Params } from '../fn/plan/api-plan-get-plan-post';
import { apiPlanGetPlanPost$Plain } from '../fn/plan/api-plan-get-plan-post-plain';
import { ApiPlanGetPlanPost$Plain$Params } from '../fn/plan/api-plan-get-plan-post-plain';
import { apiPlanGetPlansCountForCategoryGet } from '../fn/plan/api-plan-get-plans-count-for-category-get';
import { ApiPlanGetPlansCountForCategoryGet$Params } from '../fn/plan/api-plan-get-plans-count-for-category-get';
import { apiPlanGetPlansCountForCategoryGet$Plain } from '../fn/plan/api-plan-get-plans-count-for-category-get-plain';
import { ApiPlanGetPlansCountForCategoryGet$Plain$Params } from '../fn/plan/api-plan-get-plans-count-for-category-get-plain';
import { apiPlanGetPlansForInspectorGet } from '../fn/plan/api-plan-get-plans-for-inspector-get';
import { ApiPlanGetPlansForInspectorGet$Params } from '../fn/plan/api-plan-get-plans-for-inspector-get';
import { apiPlanGetPlansForInspectorGet$Plain } from '../fn/plan/api-plan-get-plans-for-inspector-get-plain';
import { ApiPlanGetPlansForInspectorGet$Plain$Params } from '../fn/plan/api-plan-get-plans-for-inspector-get-plain';
import { apiPlanGetPlansPost } from '../fn/plan/api-plan-get-plans-post';
import { ApiPlanGetPlansPost$Params } from '../fn/plan/api-plan-get-plans-post';
import { apiPlanGetPlansPost$Plain } from '../fn/plan/api-plan-get-plans-post-plain';
import { ApiPlanGetPlansPost$Plain$Params } from '../fn/plan/api-plan-get-plans-post-plain';
import { apiPlanSavePlanPatch } from '../fn/plan/api-plan-save-plan-patch';
import { ApiPlanSavePlanPatch$Params } from '../fn/plan/api-plan-save-plan-patch';
import { apiPlanSavePlanPatch$Plain } from '../fn/plan/api-plan-save-plan-patch-plain';
import { ApiPlanSavePlanPatch$Plain$Params } from '../fn/plan/api-plan-save-plan-patch-plain';
import { apiPlanSendPdfToUsersPost } from '../fn/plan/api-plan-send-pdf-to-users-post';
import { ApiPlanSendPdfToUsersPost$Params } from '../fn/plan/api-plan-send-pdf-to-users-post';
import { apiPlanSendPdfToUsersPost$Plain } from '../fn/plan/api-plan-send-pdf-to-users-post-plain';
import { ApiPlanSendPdfToUsersPost$Plain$Params } from '../fn/plan/api-plan-send-pdf-to-users-post-plain';
import { apiPlanSetNoteDuplicatedPost } from '../fn/plan/api-plan-set-note-duplicated-post';
import { ApiPlanSetNoteDuplicatedPost$Params } from '../fn/plan/api-plan-set-note-duplicated-post';
import { apiPlanSetNoteDuplicatedPost$Plain } from '../fn/plan/api-plan-set-note-duplicated-post-plain';
import { ApiPlanSetNoteDuplicatedPost$Plain$Params } from '../fn/plan/api-plan-set-note-duplicated-post-plain';
import { apiPlanUpdatePlanPatch } from '../fn/plan/api-plan-update-plan-patch';
import { ApiPlanUpdatePlanPatch$Params } from '../fn/plan/api-plan-update-plan-patch';
import { apiPlanUpdatePlanPatch$Plain } from '../fn/plan/api-plan-update-plan-patch-plain';
import { ApiPlanUpdatePlanPatch$Plain$Params } from '../fn/plan/api-plan-update-plan-patch-plain';
import { AutoCreatePlanCommandResult } from '../models/auto-create-plan-command-result';
import { BaseCommandResult } from '../models/base-command-result';
import { ChangeExcuseStatusCommandResult } from '../models/change-excuse-status-command-result';
import { CreatePlanCommandResult } from '../models/create-plan-command-result';
import { GetAllInspectorsQueryResult } from '../models/get-all-inspectors-query-result';
import { GetNoteQueryResult } from '../models/get-note-query-result';
import { GetPlanQueryResult } from '../models/get-plan-query-result';
import { GetPlansCountForCategoryQueryResult } from '../models/get-plans-count-for-category-query-result';
import { GetPlansForInspectorQueryResult } from '../models/get-plans-for-inspector-query-result';
import { GetPlansQueryResult } from '../models/get-plans-query-result';
import { SendPdfToUsersCommandResult } from '../models/send-pdf-to-users-command-result';
import { SetNoteDuplicatedCommandResult } from '../models/set-note-duplicated-command-result';

@Injectable({ providedIn: 'root' })
export class PlanService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPlanGetPlanPost()` */
  static readonly ApiPlanGetPlanPostPath = '/api/Plan/GetPlan';

  /**
   * Retrieves a specific plan along with its associated details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlanPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlanPost$Plain$Response(params?: ApiPlanGetPlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlanQueryResult>> {
    return apiPlanGetPlanPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific plan along with its associated details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlanPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlanPost$Plain(params?: ApiPlanGetPlanPost$Plain$Params, context?: HttpContext): Observable<GetPlanQueryResult> {
    return this.apiPlanGetPlanPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlanQueryResult>): GetPlanQueryResult => r.body)
    );
  }

  /**
   * Retrieves a specific plan along with its associated details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlanPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlanPost$Response(params?: ApiPlanGetPlanPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlanQueryResult>> {
    return apiPlanGetPlanPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific plan along with its associated details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlanPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlanPost(params?: ApiPlanGetPlanPost$Params, context?: HttpContext): Observable<GetPlanQueryResult> {
    return this.apiPlanGetPlanPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlanQueryResult>): GetPlanQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPlanGetPlansForInspectorGet()` */
  static readonly ApiPlanGetPlansForInspectorGetPath = '/api/Plan/GetPlansForInspector';

  /**
   * Retrieves all plans based on provided filters for mobile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlansForInspectorGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansForInspectorGet$Plain$Response(params?: ApiPlanGetPlansForInspectorGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansForInspectorQueryResult>> {
    return apiPlanGetPlansForInspectorGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all plans based on provided filters for mobile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlansForInspectorGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansForInspectorGet$Plain(params?: ApiPlanGetPlansForInspectorGet$Plain$Params, context?: HttpContext): Observable<GetPlansForInspectorQueryResult> {
    return this.apiPlanGetPlansForInspectorGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlansForInspectorQueryResult>): GetPlansForInspectorQueryResult => r.body)
    );
  }

  /**
   * Retrieves all plans based on provided filters for mobile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlansForInspectorGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansForInspectorGet$Response(params?: ApiPlanGetPlansForInspectorGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansForInspectorQueryResult>> {
    return apiPlanGetPlansForInspectorGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all plans based on provided filters for mobile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlansForInspectorGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansForInspectorGet(params?: ApiPlanGetPlansForInspectorGet$Params, context?: HttpContext): Observable<GetPlansForInspectorQueryResult> {
    return this.apiPlanGetPlansForInspectorGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlansForInspectorQueryResult>): GetPlansForInspectorQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPlanGetNoteGet()` */
  static readonly ApiPlanGetNoteGetPath = '/api/Plan/GetNote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetNoteGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetNoteGet$Plain$Response(params?: ApiPlanGetNoteGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNoteQueryResult>> {
    return apiPlanGetNoteGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetNoteGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetNoteGet$Plain(params?: ApiPlanGetNoteGet$Plain$Params, context?: HttpContext): Observable<GetNoteQueryResult> {
    return this.apiPlanGetNoteGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNoteQueryResult>): GetNoteQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetNoteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetNoteGet$Response(params?: ApiPlanGetNoteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNoteQueryResult>> {
    return apiPlanGetNoteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetNoteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetNoteGet(params?: ApiPlanGetNoteGet$Params, context?: HttpContext): Observable<GetNoteQueryResult> {
    return this.apiPlanGetNoteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNoteQueryResult>): GetNoteQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPlanGetPlansCountForCategoryGet()` */
  static readonly ApiPlanGetPlansCountForCategoryGetPath = '/api/Plan/GetPlansCountForCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlansCountForCategoryGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansCountForCategoryGet$Plain$Response(params?: ApiPlanGetPlansCountForCategoryGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansCountForCategoryQueryResult>> {
    return apiPlanGetPlansCountForCategoryGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlansCountForCategoryGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansCountForCategoryGet$Plain(params?: ApiPlanGetPlansCountForCategoryGet$Plain$Params, context?: HttpContext): Observable<GetPlansCountForCategoryQueryResult> {
    return this.apiPlanGetPlansCountForCategoryGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlansCountForCategoryQueryResult>): GetPlansCountForCategoryQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlansCountForCategoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansCountForCategoryGet$Response(params?: ApiPlanGetPlansCountForCategoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansCountForCategoryQueryResult>> {
    return apiPlanGetPlansCountForCategoryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlansCountForCategoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPlanGetPlansCountForCategoryGet(params?: ApiPlanGetPlansCountForCategoryGet$Params, context?: HttpContext): Observable<GetPlansCountForCategoryQueryResult> {
    return this.apiPlanGetPlansCountForCategoryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlansCountForCategoryQueryResult>): GetPlansCountForCategoryQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPlanGetPlansPost()` */
  static readonly ApiPlanGetPlansPostPath = '/api/Plan/GetPlans';

  /**
   * Retrieves all plans based on provided filters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlansPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlansPost$Plain$Response(params?: ApiPlanGetPlansPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansQueryResult>> {
    return apiPlanGetPlansPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all plans based on provided filters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlansPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlansPost$Plain(params?: ApiPlanGetPlansPost$Plain$Params, context?: HttpContext): Observable<GetPlansQueryResult> {
    return this.apiPlanGetPlansPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlansQueryResult>): GetPlansQueryResult => r.body)
    );
  }

  /**
   * Retrieves all plans based on provided filters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetPlansPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlansPost$Response(params?: ApiPlanGetPlansPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansQueryResult>> {
    return apiPlanGetPlansPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all plans based on provided filters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetPlansPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetPlansPost(params?: ApiPlanGetPlansPost$Params, context?: HttpContext): Observable<GetPlansQueryResult> {
    return this.apiPlanGetPlansPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPlansQueryResult>): GetPlansQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPlanGetAllInspectorsPost()` */
  static readonly ApiPlanGetAllInspectorsPostPath = '/api/Plan/GetAllInspectors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetAllInspectorsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetAllInspectorsPost$Plain$Response(params?: ApiPlanGetAllInspectorsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllInspectorsQueryResult>> {
    return apiPlanGetAllInspectorsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetAllInspectorsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetAllInspectorsPost$Plain(params?: ApiPlanGetAllInspectorsPost$Plain$Params, context?: HttpContext): Observable<GetAllInspectorsQueryResult> {
    return this.apiPlanGetAllInspectorsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllInspectorsQueryResult>): GetAllInspectorsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanGetAllInspectorsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetAllInspectorsPost$Response(params?: ApiPlanGetAllInspectorsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllInspectorsQueryResult>> {
    return apiPlanGetAllInspectorsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanGetAllInspectorsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanGetAllInspectorsPost(params?: ApiPlanGetAllInspectorsPost$Params, context?: HttpContext): Observable<GetAllInspectorsQueryResult> {
    return this.apiPlanGetAllInspectorsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllInspectorsQueryResult>): GetAllInspectorsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPlanCreatePlanPost()` */
  static readonly ApiPlanCreatePlanPostPath = '/api/Plan/CreatePlan';

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanCreatePlanPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanCreatePlanPost$Plain$Response(params?: ApiPlanCreatePlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePlanCommandResult>> {
    return apiPlanCreatePlanPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanCreatePlanPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanCreatePlanPost$Plain(params?: ApiPlanCreatePlanPost$Plain$Params, context?: HttpContext): Observable<CreatePlanCommandResult> {
    return this.apiPlanCreatePlanPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePlanCommandResult>): CreatePlanCommandResult => r.body)
    );
  }

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanCreatePlanPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanCreatePlanPost$Response(params?: ApiPlanCreatePlanPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePlanCommandResult>> {
    return apiPlanCreatePlanPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanCreatePlanPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanCreatePlanPost(params?: ApiPlanCreatePlanPost$Params, context?: HttpContext): Observable<CreatePlanCommandResult> {
    return this.apiPlanCreatePlanPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePlanCommandResult>): CreatePlanCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanSetNoteDuplicatedPost()` */
  static readonly ApiPlanSetNoteDuplicatedPostPath = '/api/Plan/SetNoteDuplicated';

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanSetNoteDuplicatedPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSetNoteDuplicatedPost$Plain$Response(params?: ApiPlanSetNoteDuplicatedPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SetNoteDuplicatedCommandResult>> {
    return apiPlanSetNoteDuplicatedPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanSetNoteDuplicatedPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSetNoteDuplicatedPost$Plain(params?: ApiPlanSetNoteDuplicatedPost$Plain$Params, context?: HttpContext): Observable<SetNoteDuplicatedCommandResult> {
    return this.apiPlanSetNoteDuplicatedPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetNoteDuplicatedCommandResult>): SetNoteDuplicatedCommandResult => r.body)
    );
  }

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanSetNoteDuplicatedPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSetNoteDuplicatedPost$Response(params?: ApiPlanSetNoteDuplicatedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SetNoteDuplicatedCommandResult>> {
    return apiPlanSetNoteDuplicatedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanSetNoteDuplicatedPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSetNoteDuplicatedPost(params?: ApiPlanSetNoteDuplicatedPost$Params, context?: HttpContext): Observable<SetNoteDuplicatedCommandResult> {
    return this.apiPlanSetNoteDuplicatedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetNoteDuplicatedCommandResult>): SetNoteDuplicatedCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanAutoCreatePlanPost()` */
  static readonly ApiPlanAutoCreatePlanPostPath = '/api/Plan/AutoCreatePlan';

  /**
   * Creates a new automated plans.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAutoCreatePlanPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAutoCreatePlanPost$Plain$Response(params?: ApiPlanAutoCreatePlanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoCreatePlanCommandResult>> {
    return apiPlanAutoCreatePlanPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new automated plans.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAutoCreatePlanPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAutoCreatePlanPost$Plain(params?: ApiPlanAutoCreatePlanPost$Plain$Params, context?: HttpContext): Observable<AutoCreatePlanCommandResult> {
    return this.apiPlanAutoCreatePlanPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutoCreatePlanCommandResult>): AutoCreatePlanCommandResult => r.body)
    );
  }

  /**
   * Creates a new automated plans.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAutoCreatePlanPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAutoCreatePlanPost$Response(params?: ApiPlanAutoCreatePlanPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoCreatePlanCommandResult>> {
    return apiPlanAutoCreatePlanPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new automated plans.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAutoCreatePlanPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAutoCreatePlanPost(params?: ApiPlanAutoCreatePlanPost$Params, context?: HttpContext): Observable<AutoCreatePlanCommandResult> {
    return this.apiPlanAutoCreatePlanPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AutoCreatePlanCommandResult>): AutoCreatePlanCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanAddExcusePost()` */
  static readonly ApiPlanAddExcusePostPath = '/api/Plan/AddExcuse';

  /**
   * Add Excuse to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddExcusePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddExcusePost$Plain$Response(params?: ApiPlanAddExcusePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddExcuseCommandResult>> {
    return apiPlanAddExcusePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Excuse to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddExcusePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddExcusePost$Plain(params?: ApiPlanAddExcusePost$Plain$Params, context?: HttpContext): Observable<AddExcuseCommandResult> {
    return this.apiPlanAddExcusePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddExcuseCommandResult>): AddExcuseCommandResult => r.body)
    );
  }

  /**
   * Add Excuse to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddExcusePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddExcusePost$Response(params?: ApiPlanAddExcusePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddExcuseCommandResult>> {
    return apiPlanAddExcusePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Excuse to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddExcusePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddExcusePost(params?: ApiPlanAddExcusePost$Params, context?: HttpContext): Observable<AddExcuseCommandResult> {
    return this.apiPlanAddExcusePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddExcuseCommandResult>): AddExcuseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanChangeExcuseStatusPost()` */
  static readonly ApiPlanChangeExcuseStatusPostPath = '/api/Plan/ChangeExcuseStatus';

  /**
   * Change Excuse Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanChangeExcuseStatusPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangeExcuseStatusPost$Plain$Response(params?: ApiPlanChangeExcuseStatusPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeExcuseStatusCommandResult>> {
    return apiPlanChangeExcuseStatusPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Change Excuse Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanChangeExcuseStatusPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangeExcuseStatusPost$Plain(params?: ApiPlanChangeExcuseStatusPost$Plain$Params, context?: HttpContext): Observable<ChangeExcuseStatusCommandResult> {
    return this.apiPlanChangeExcuseStatusPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeExcuseStatusCommandResult>): ChangeExcuseStatusCommandResult => r.body)
    );
  }

  /**
   * Change Excuse Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanChangeExcuseStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangeExcuseStatusPost$Response(params?: ApiPlanChangeExcuseStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeExcuseStatusCommandResult>> {
    return apiPlanChangeExcuseStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Change Excuse Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanChangeExcuseStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangeExcuseStatusPost(params?: ApiPlanChangeExcuseStatusPost$Params, context?: HttpContext): Observable<ChangeExcuseStatusCommandResult> {
    return this.apiPlanChangeExcuseStatusPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeExcuseStatusCommandResult>): ChangeExcuseStatusCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanUpdatePlanPatch()` */
  static readonly ApiPlanUpdatePlanPatchPath = '/api/Plan/UpdatePlan';

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanUpdatePlanPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanUpdatePlanPatch$Plain$Response(params?: ApiPlanUpdatePlanPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanUpdatePlanPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanUpdatePlanPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanUpdatePlanPatch$Plain(params?: ApiPlanUpdatePlanPatch$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanUpdatePlanPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanUpdatePlanPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanUpdatePlanPatch$Response(params?: ApiPlanUpdatePlanPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanUpdatePlanPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanUpdatePlanPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanUpdatePlanPatch(params?: ApiPlanUpdatePlanPatch$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanUpdatePlanPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanSavePlanPatch()` */
  static readonly ApiPlanSavePlanPatchPath = '/api/Plan/SavePlan';

  /**
   * Save an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanSavePlanPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSavePlanPatch$Plain$Response(params?: ApiPlanSavePlanPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanSavePlanPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Save an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanSavePlanPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSavePlanPatch$Plain(params?: ApiPlanSavePlanPatch$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanSavePlanPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * Save an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanSavePlanPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSavePlanPatch$Response(params?: ApiPlanSavePlanPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanSavePlanPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Save an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanSavePlanPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanSavePlanPatch(params?: ApiPlanSavePlanPatch$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanSavePlanPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanAddCategoryToPlanPatch()` */
  static readonly ApiPlanAddCategoryToPlanPatchPath = '/api/Plan/AddCategoryToPlan';

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddCategoryToPlanPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddCategoryToPlanPatch$Plain$Response(params?: ApiPlanAddCategoryToPlanPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddCategoryToPlanCommandResult>> {
    return apiPlanAddCategoryToPlanPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddCategoryToPlanPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddCategoryToPlanPatch$Plain(params?: ApiPlanAddCategoryToPlanPatch$Plain$Params, context?: HttpContext): Observable<AddCategoryToPlanCommandResult> {
    return this.apiPlanAddCategoryToPlanPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddCategoryToPlanCommandResult>): AddCategoryToPlanCommandResult => r.body)
    );
  }

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddCategoryToPlanPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddCategoryToPlanPatch$Response(params?: ApiPlanAddCategoryToPlanPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AddCategoryToPlanCommandResult>> {
    return apiPlanAddCategoryToPlanPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddCategoryToPlanPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddCategoryToPlanPatch(params?: ApiPlanAddCategoryToPlanPatch$Params, context?: HttpContext): Observable<AddCategoryToPlanCommandResult> {
    return this.apiPlanAddCategoryToPlanPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddCategoryToPlanCommandResult>): AddCategoryToPlanCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanAddPlanProgressPatch()` */
  static readonly ApiPlanAddPlanProgressPatchPath = '/api/Plan/AddPlanProgress';

  /**
   * Updates an existing planProgress.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddPlanProgressPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddPlanProgressPatch$Plain$Response(params?: ApiPlanAddPlanProgressPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddPlanProgressCommandResult>> {
    return apiPlanAddPlanProgressPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing planProgress.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddPlanProgressPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddPlanProgressPatch$Plain(params?: ApiPlanAddPlanProgressPatch$Plain$Params, context?: HttpContext): Observable<AddPlanProgressCommandResult> {
    return this.apiPlanAddPlanProgressPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddPlanProgressCommandResult>): AddPlanProgressCommandResult => r.body)
    );
  }

  /**
   * Updates an existing planProgress.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddPlanProgressPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddPlanProgressPatch$Response(params?: ApiPlanAddPlanProgressPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AddPlanProgressCommandResult>> {
    return apiPlanAddPlanProgressPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing planProgress.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddPlanProgressPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddPlanProgressPatch(params?: ApiPlanAddPlanProgressPatch$Params, context?: HttpContext): Observable<AddPlanProgressCommandResult> {
    return this.apiPlanAddPlanProgressPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddPlanProgressCommandResult>): AddPlanProgressCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanAddInspectorEvaluationPatch()` */
  static readonly ApiPlanAddInspectorEvaluationPatchPath = '/api/Plan/AddInspectorEvaluation';

  /**
   * Add Inspector Evaluation on an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddInspectorEvaluationPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddInspectorEvaluationPatch$Plain$Response(params?: ApiPlanAddInspectorEvaluationPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanAddInspectorEvaluationPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Inspector Evaluation on an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddInspectorEvaluationPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddInspectorEvaluationPatch$Plain(params?: ApiPlanAddInspectorEvaluationPatch$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanAddInspectorEvaluationPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * Add Inspector Evaluation on an existing plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanAddInspectorEvaluationPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddInspectorEvaluationPatch$Response(params?: ApiPlanAddInspectorEvaluationPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanAddInspectorEvaluationPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Inspector Evaluation on an existing plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanAddInspectorEvaluationPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanAddInspectorEvaluationPatch(params?: ApiPlanAddInspectorEvaluationPatch$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanAddInspectorEvaluationPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanChangePlanStatusPatch()` */
  static readonly ApiPlanChangePlanStatusPatchPath = '/api/Plan/ChangePlanStatus';

  /**
   * Change Plan Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanChangePlanStatusPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangePlanStatusPatch$Plain$Response(params?: ApiPlanChangePlanStatusPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanChangePlanStatusPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Change Plan Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanChangePlanStatusPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangePlanStatusPatch$Plain(params?: ApiPlanChangePlanStatusPatch$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanChangePlanStatusPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * Change Plan Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanChangePlanStatusPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangePlanStatusPatch$Response(params?: ApiPlanChangePlanStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanChangePlanStatusPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Change Plan Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanChangePlanStatusPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanChangePlanStatusPatch(params?: ApiPlanChangePlanStatusPatch$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanChangePlanStatusPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanDeletePlanDelete()` */
  static readonly ApiPlanDeletePlanDeletePath = '/api/Plan/DeletePlan';

  /**
   * Deletes a specific plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanDeletePlanDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanDeletePlanDelete$Plain$Response(params?: ApiPlanDeletePlanDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanDeletePlanDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a specific plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanDeletePlanDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanDeletePlanDelete$Plain(params?: ApiPlanDeletePlanDelete$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanDeletePlanDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * Deletes a specific plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanDeletePlanDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanDeletePlanDelete$Response(params?: ApiPlanDeletePlanDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiPlanDeletePlanDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a specific plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanDeletePlanDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPlanDeletePlanDelete(params?: ApiPlanDeletePlanDelete$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiPlanDeletePlanDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPlanSendPdfToUsersPost()` */
  static readonly ApiPlanSendPdfToUsersPostPath = '/api/Plan/SendPdfToUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanSendPdfToUsersPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPlanSendPdfToUsersPost$Plain$Response(params?: ApiPlanSendPdfToUsersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SendPdfToUsersCommandResult>> {
    return apiPlanSendPdfToUsersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanSendPdfToUsersPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPlanSendPdfToUsersPost$Plain(params?: ApiPlanSendPdfToUsersPost$Plain$Params, context?: HttpContext): Observable<SendPdfToUsersCommandResult> {
    return this.apiPlanSendPdfToUsersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SendPdfToUsersCommandResult>): SendPdfToUsersCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPlanSendPdfToUsersPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPlanSendPdfToUsersPost$Response(params?: ApiPlanSendPdfToUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SendPdfToUsersCommandResult>> {
    return apiPlanSendPdfToUsersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPlanSendPdfToUsersPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiPlanSendPdfToUsersPost(params?: ApiPlanSendPdfToUsersPost$Params, context?: HttpContext): Observable<SendPdfToUsersCommandResult> {
    return this.apiPlanSendPdfToUsersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SendPdfToUsersCommandResult>): SendPdfToUsersCommandResult => r.body)
    );
  }

}
